import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HANDOVER_TYPES_AREA_REASON } from 'mocks/mock-handover-types-area-reason';
import {
  Handover,
  ResultHandovers,
  ResultHandoversHome,
} from 'src/app/interfaces/handover';
import { HandoverTypeAreaReason } from 'src/app/interfaces/handover-type-area-reason';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentComponent implements OnInit {
  isLoadingHandovers = false;
  handoverTypesAreaReason: HandoverTypeAreaReason[] = [];
  handoversGeneral: Handover[] | undefined;
  totalHandoversGeneral!: number;
  handoversSentPersonal: Handover[] | undefined;
  totalHandoversSentPersonal!: number;
  handoversSentTeam: Handover[] | undefined;
  totalHandoversSentTeam!: number;
  handoversEdition: Handover[] | undefined;
  totalHandoversEdition!: number;
  handoversInboxPersonal: Handover[] | undefined;
  totalHandoversInboxPersonal!: number;
  handoversRejectedPersonal: Handover[] | undefined;
  totalHandoversRejectedPersonal!: number;
  handoversRejectedTeam: Handover[] | undefined;
  totalHandoversRejectedTeam!: number;
  handoversInboxTeam: Handover[] | undefined;
  totalHandoversInboxTeam!: number;
  handoversInboxEditionTeam: Handover[] | undefined;
  totalHandoversInboxEditionTeam!: number;
  showInboxPersonal = true;
  showInboxEdition = true;
  showSentPersonal = true;
  showRejectedPersonal = true;
  sortDirection = 'desc';
  searchGeneral = '';
  searchInboxPersonal = '';
  searchInboxTeam = '';
  searchEditionPersonal = '';
  searchEditionTeam = '';
  searchRejectedPersonal = '';
  searchRejectedTeam = '';
  searchSentPersonal = '';
  searchSentTeam = '';

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    this.getHandoverTypesAreaReason();
    this.getHandoversHome();
  }

  getHandoverTypesAreaReason(): void {
    this.handoverTypesAreaReason = HANDOVER_TYPES_AREA_REASON;
  }

  getHandoversHome(): void {
    this.isLoadingHandovers = true;
    this.handoverService
      .getHandoversHome(30, 0, this.sortDirection)
      .subscribe((res: ResultHandoversHome) => {
        this.handoversGeneral = res.handoversGeneral.handovers;
        this.totalHandoversGeneral = res.handoversGeneral.totalHandovers;
        this.handoversSentPersonal = res.handoversSentPersonal.handovers;
        this.totalHandoversSentPersonal =
          res.handoversSentPersonal.totalHandovers;
        this.handoversEdition = res.handoversEdition.handovers;
        this.totalHandoversEdition = res.handoversEdition.totalHandovers;
        this.handoversInboxPersonal = res.handoversInboxPersonal.handovers;
        this.totalHandoversInboxPersonal =
          res.handoversInboxPersonal.totalHandovers;
        this.handoversRejectedPersonal =
          res.handoversRejectedPersonal.handovers;
        this.totalHandoversRejectedPersonal =
          res.handoversRejectedPersonal.totalHandovers;
        this.handoversInboxTeam = res.handoversInboxTeam.handovers;
        this.totalHandoversInboxTeam = res.handoversInboxTeam.totalHandovers;
        this.handoversInboxEditionTeam =
          res.handoversInboxEditionTeam.handovers;
        this.totalHandoversInboxEditionTeam =
          res.handoversInboxEditionTeam.totalHandovers;
        this.handoversRejectedTeam = res.handoversRejectedTeam.handovers;
        this.totalHandoversRejectedTeam =
          res.handoversRejectedTeam.totalHandovers;
        this.handoversSentTeam = res.handoversSentTeam.handovers;
        this.totalHandoversSentTeam = res.handoversSentTeam.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  eventReload(reload: boolean) {
    this.getHandoversHome();
  }
  eventShowPersonal(showInbox: boolean) {
    this.showInboxPersonal = showInbox;
  }
  eventShowEdition(showInbox: boolean) {
    this.showInboxEdition = showInbox;
  }
  eventShowSentPersonal(showInbox: boolean) {
    this.showSentPersonal = showInbox;
  }
  eventShowRejectedPersonal(showInbox: boolean) {
    this.showRejectedPersonal = showInbox;
  }

  getHandoversHomeGeneralWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchGeneral = search;
    this.handoverService
      .getHandoversHomeGeneral(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversGeneral = res.handovers;
        this.totalHandoversGeneral = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeInboxPersonalWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchInboxPersonal = search;
    this.handoverService
      .getHandoversHomeInboxPersonal(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversInboxPersonal = res.handovers;
        this.totalHandoversInboxPersonal = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeInboxTeamWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchInboxTeam = search;
    this.handoverService
      .getHandoversHomeInboxTeam(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversInboxTeam = res.handovers;
        this.totalHandoversInboxTeam = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeEditionPersonalWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchEditionPersonal = search;
    this.handoverService
      .getHandoversHomeEditionPersonal(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversEdition = res.handovers;
        this.totalHandoversEdition = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeEditionTeamWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchEditionTeam = search;
    this.handoverService
      .getHandoversHomeEditionTeam(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversInboxEditionTeam = res.handovers;
        this.totalHandoversInboxEditionTeam = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeSentPersonalWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchSentPersonal = search;
    this.handoverService
      .getHandoversHomeSentPersonal(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversSentPersonal = res.handovers;
        this.totalHandoversSentPersonal = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeRejectedPersonalWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchRejectedPersonal = search;
    this.handoverService
      .getHandoversHomeRejectedPersonal(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversRejectedPersonal = res.handovers;
        this.totalHandoversRejectedPersonal = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeSentTeamWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchSentTeam = search;
    this.handoverService
      .getHandoversHomeSentTeam(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversSentTeam = res.handovers;
        this.totalHandoversSentTeam = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  getHandoversHomeRejectedTeamWithFilter(search: string): void {
    this.isLoadingHandovers = true;
    this.searchRejectedTeam = search;
    this.handoverService
      .getHandoversHomeRejectedTeam(30, 0, this.sortDirection, search)
      .subscribe((res: ResultHandovers) => {
        this.handoversRejectedTeam = res.handovers;
        this.totalHandoversRejectedTeam = res.totalHandovers;
        this.isLoadingHandovers = false;
      });
  }

  /**
   * Handles the 'sort by date' change event coming from
   * app-home-content-inbox-general component.
   */
  reorderInboxGeneral(sortDirection: string): void {
    this.sortDirection = sortDirection;
    this.getHandoversHomeGeneralWithFilter(this.searchGeneral);
  }
}
